<template>
  <nav class="navbar is-primary" role="navigation">
    <div class="container is-fluid">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          <img src="../assets/logo_dark.png" alt="BA FLIGHT" />
        </a>
      </div>
    </div>
  </nav>
</template>
